import React, { Component } from 'react';
import { Form } from 'react-form';
import Popup from '../../Popup';
import { Input, Select } from '../../Form';
import { required } from '../../../utils/validation';
import { SupportLink } from '../../Links';
import styles from './addOrUpdateDualMatchEventDrawPopup.scss';

class AddOrUpdateDualMatchEventDrawPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            drawFormatOptions: [
                {
                    id: 1,
                    value: 'singles',
                    label: 'Singles',
                },
                {
                    id: 2,
                    value: 'doubles',
                    label: 'Doubles',
                },
            ],
            submitting: false,
            submitSuccessful: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(values) {
        this.setState({
            submitting: true,
            submitSuccessful: false,
            addOrUpdateError: false,
        });

        try {
            await this.props.onCtaClickAsync(values);
            this.setState({
                submitting: false,
                submitSuccessful: true,
            });
        } catch (error) {
            this.setState({
                submitting: false,
                addOrUpdateError: true,
            });
        }
    }

    render() {
        const {
            defaultValues,
            isEdit,
            onCloseClick,
            themeV3,
        } = this.props;

        const successMsg = `Lineup successfully ${isEdit ? 'updated' : 'added'}.`;
        return (
            <Popup
                className={`popup-md clear-over-flow`}
                popUpClassName={`${styles.addOrUpdateDualMatchEventDrawPopup} ${themeV3 ? styles.themeV3 : ''}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
            >
                <div className={`${styles.section} pt0`}>
                    <h4>
                        {isEdit ? 'Update Lineup' : 'Add Lineup'}
                    </h4>
                </div>
                <div className={`${styles.section} ${themeV3 ? styles.themeV3 : ''} pt0`}>
                    <Form onSubmit={values => this.handleSubmit(values)} id="addOrUpdateDualMatchEventDrawForm" defaultValues={defaultValues}>
                        {(formApi) => {
                            const { submitForm } = formApi;
                            return (
                                <form onSubmit={submitForm} id="addOrUpdateDualMatchEventDrawForm">
                                    {!this.state.submitSuccessful && (
                                        <React.Fragment>
                                            {!isEdit && (
                                                <div className="row mb16">
                                                    <div className={`col-12 mb24`}>
                                                        <Select
                                                            key={`event-format-type`}
                                                            id={`event-format-type`}
                                                            label="Singles/Doubles"
                                                            field={`formatTypeId`}
                                                            value={defaultValues.formatTypeId}
                                                            hiddenDefault={true}
                                                            options={this.state.drawFormatOptions}
                                                            validate={required}
                                                            themeV3={themeV3}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="row mb16">
                                                <div className={`col-12 mb24`}>
                                                    <Input
                                                        key={`draw-name`}
                                                        id={`draw-name`}
                                                        label="Name"
                                                        field={`name`}
                                                        validate={required}
                                                        themeV3={themeV3}
                                                    />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className="row mb24">
                                            <div className="col-12">
                                                {themeV3 ? <p>{successMsg}</p> : successMsg}
                                            </div>
                                        </div>
                                    )}
                                    <hr />
                                    {this.state.addOrUpdateError && (
                                        <div className="pb24 text-center text-error text-small">
                                            An error occurred while adding this draw. If this problem persists, please contact our <SupportLink target="_blank">support team.</SupportLink>
                                        </div>
                                    )}
                                    {this.state.submitSuccessful && (
                                        <div className={`row ${themeV3 ? styles.themeV3 : ''}`}>
                                            <div className="col-12 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Got it
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {!this.state.submitSuccessful && (
                                        <div className={`row ${themeV3 ? styles.themeV3 : ''}`}>
                                            <div className="col-12 col-md-6 mb16">
                                                <button
                                                    onClick={onCloseClick}
                                                    type="button"
                                                    className="btn btn-default btn-xl text-uppercase btn-block"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-xl text-uppercase btn-block"
                                                    disabled={this.state.submitting}
                                                >
                                                    {isEdit ? 'Update' : 'Add'}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            );
                        }}
                    </Form>
                </div>
            </Popup>
        );
    }
}

export default AddOrUpdateDualMatchEventDrawPopup;
